export const IsValidEmail = email => {
  const emailRegex = /@/;
  
  if (!email || email.indexOf('@') === -1) {
    return false;
  }

  return emailRegex.test(email);
}
